import React from 'react'
import { Translate } from 'react-localize-redux'
import { Card, CardContent } from '@material-ui/core'
import PropTypes from 'prop-types'
import { SummaryCircle } from 'components'

const TeamResults = ({ data }) => (
  <Translate>
    {({ translate }) => (
      <Card>
        <CardContent>
          <SummaryCircle
            value={data.matches_played}
            maxValue=""
            title={translate('team.matches')}
          />
          <SummaryCircle
            value={data.goals_scored}
            maxValue={translate('team.goals')}
            title={translate('team.scored')}
          />
          <SummaryCircle
            value={data.goals_received}
            maxValue={translate('team.goals')}
            title={translate('team.received')}
          />
        </CardContent>
      </Card>
    )}
  </Translate>
)

TeamResults.propTypes = {
  data: PropTypes.shape({
    matches_played: PropTypes.number.isRequired,
    goals_scored: PropTypes.number.isRequired,
    goals_received: PropTypes.number.isRequired,
  }).isRequired,
}

export default TeamResults
